export default {
  SET_DATA(state, data) {
    state.data = data
  },
  SET_FILE_LIST(state, data) {
    state.fileList = data
  },
  DELETE_FILE_FROM_FILE_LIST(state, fileID) {
    const index = state.fileList.findIndex(f => f.uploadedfileid === fileID)
    if (index === -1) return
    state.fileList.splice(index, 1)
  }
}
